import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-10 text-center">
      <svg width="96" height="64" viewBox="0 0 96 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="6" y="14" width="84" height="34" rx="6" fill="#E5E7EB" />
        <rect x="14" y="22" width="56" height="6" rx="3" fill="#F3F4F6" />
        <rect x="14" y="32" width="40" height="4" rx="2" fill="#F3F4F6" />
        <circle cx="78" cy="48" r="10" fill="#2BD4A7" />
        <path d="M73 48l3 3 6-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <p className="mt-4 font-display text-base font-semibold text-ink">{title}</p>
      {description ? <p className="mt-1 text-sm text-muted">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
